import React, { useState } from 'react';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import { Visibility, VisibilityOff, Autorenew as AutorenewIcon } from '@mui/icons-material';

export default function PasswordField({ onGenerate, ...props }) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <TextField
      {...props}
      type={showPassword ? 'text' : 'password'}
      InputProps={{
        ...props.InputProps,
        startAdornment: onGenerate ? (
          <InputAdornment position="start">
            <IconButton size="small" title="Generate Password" onClick={onGenerate}>
              <AutorenewIcon fontSize="small" />
            </IconButton>
          </InputAdornment>
        ) : props.InputProps?.startAdornment,
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              onClick={() => setShowPassword(!showPassword)}
              edge="end"
            >
              {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}
